module.exports = __webpack_public_path__ + "img/nestle.e1dbdead.png";